import React from 'react';
import './Sidebar.css';

function Sidebar({ currentSection, onSectionChange, sections }) {
  const defaultSections = [
    { key: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { key: 'files', label: 'Files', icon: '🗂️' },
    { key: 'images', label: 'Images', icon: '🖼️' },
    { key: 'pastes', label: 'Pastes', icon: '📋' },
    { key: 'urls', label: 'Short URLs', icon: '🔗' },
    { key: 'health', label: 'System Health', icon: '🏥' },
    { key: 'settings', label: 'Settings', icon: '⚙️' },
  ];
  const sectionList = sections || defaultSections;
  return (
    <aside className="sidebar">
      <ul>
        {sectionList.map(section => (
          <li
            key={section.key}
            className={currentSection === section.key ? 'active' : ''}
            onClick={() => onSectionChange(section.key)}
          >
            <span className="sidebar-icon">{section.icon}</span>
            {section.label}
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Sidebar;
